import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { generateAssignments } from '../../app/testing/generators/assignments-api.generator';
import {
  AssignmentApiModel,
  AssignmentLoadPriorityEnum,
} from '../models/assignment-api.model';
import { MwLoadOptionsService } from './utils/load-options.service';

@Injectable()
export class MwAssignmentsApiService {
  assignmentList: AssignmentApiModel[] = [];
  private totalCount = 65;

  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {
    this.assignmentList = generateAssignments(this.totalCount);
  }

  getAssignments(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<AssignmentApiModel[]>> {
    const query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';

    return this.http.authGet<MwPayloadModel<AssignmentApiModel[]>>(
      `/transport/v1/Companies/{companyId}/Assignments${
        query.length > 0 ? '?' + query : ''
      }`
    );
  }

  getAssignment(assignmentId: number): Observable<AssignmentApiModel> {
    const request = new MwLoadOptions({
      take: 1,
      filter: [['assignmentId', '=', assignmentId]],
      hasCount: true,
      numericParameters: {
        assignmentId: true,
      },
    });

    return this.getAssignments(request).pipe(
      first(),
      map((i: MwPayloadModel<AssignmentApiModel[]>) => i?.results?.[0])
    );
  }

  createAssignment(
    assignment: AssignmentApiModel
  ): Observable<AssignmentApiModel> {
    this.fillNonNullableFields(assignment);
    return this.http.authPost<AssignmentApiModel>(
      `/transport/v1/Companies/{companyId}/Assignments`,
      {
        body: assignment,
      }
    );
  }

  updateAssignment(
    assignment: AssignmentApiModel
  ): Observable<AssignmentApiModel> {
    this.fillNonNullableFields(assignment);
    return this.http.authPut<AssignmentApiModel>(
      `/transport/v1/Companies/{companyId}/Assignments`,
      {
        body: assignment,
      }
    );
  }

  deleteAssignment(assignment: AssignmentApiModel): Observable<any> {
    return this.http.authDelete(
      `/transport/v1/Companies/{companyId}/Assignments`,
      {
        body: assignment,
      }
    );
  }

  private fillNonNullableFields(assignment: AssignmentApiModel): void {
    assignment.quantity = assignment.quantity || 0;
    assignment.isReturnDelivery = assignment.isReturnDelivery || false;
    assignment.isRequestedVehicleWithTrailer =
      assignment.isRequestedVehicleWithTrailer || false;
    assignment.loadingTimePriority =
      assignment.loadingTimePriority || AssignmentLoadPriorityEnum.none;
    assignment.unloadingTimePriority =
      assignment.unloadingTimePriority || AssignmentLoadPriorityEnum.none;
  }
}
